import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './vite/App'
import { AppContext } from './config/context'

import { PLATFORM, handleLogout, addRecord, updateRecord, setRecord, listRecords, deleteRecord, fetchRecords } from './config/firebase'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppContext.Provider value={{PLATFORM, handleLogout, addRecord, updateRecord, setRecord, listRecords, deleteRecord, fetchRecords}}>
      <App />
    </AppContext.Provider>
  </React.StrictMode>,
)
